import { render, staticRenderFns } from "./ReferralPromotion.vue?vue&type=template&id=02e83e86&"
import script from "./ReferralPromotion.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotion.vue?vue&type=script&lang=js&"
import style0 from "./ReferralPromotion.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02e83e86')) {
      api.createRecord('02e83e86', component.options)
    } else {
      api.reload('02e83e86', component.options)
    }
    module.hot.accept("./ReferralPromotion.vue?vue&type=template&id=02e83e86&", function () {
      api.rerender('02e83e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReferralPromotion.vue"
export default component.exports